module.exports = __webpack_public_path__ + "img/alexandria_blind_faith.f618a5ed.png";